export const PERMANENTLY_EXCLUDED_FIELDS = [
  "id",
  "acl",
  "created",
  "client",
  "creator",
  "editor",
  "updated",
  "createdAt",
  "updatedAt",
  "isActive",
  "password",
  "reEnterPassword",
  "banks",
  "user",
];

export function getIndexFieldsOrdered(targetSchema) {
  if (!targetSchema?.fields) return [];
  const entries = Object.entries(targetSchema.fields).filter(
    ([, opts]) =>
      opts && (opts._index === true || typeof opts._index === "number"),
  );
  entries.sort((a, b) => {
    const na = Number(a[1]._index);
    const nb = Number(b[1]._index);
    if (na !== nb) return na - nb;
    return 0;
  });
  return entries.map(([name]) => name);
}

export function formatPointerDisplay(value, targetCollection, schemas = []) {
  if (value === undefined || value === null) return "-";
  const targetSchema = Array.isArray(schemas)
    ? schemas.find((s) => s && s.collection === targetCollection)
    : null;
  const indexFields = targetSchema ? getIndexFieldsOrdered(targetSchema) : [];
  const orderedFields =
    indexFields.length > 0 ? indexFields : ["name", "code", "id"];
  const isObject = value && typeof value === "object" && !Array.isArray(value);
  if (isObject) {
    const parts = orderedFields
      .filter(
        (f) => value[f] !== undefined && value[f] !== null && value[f] !== "",
      )
      .map((f) => String(value[f]));
    return parts.length > 0 ? parts.join(" - ") : value.id || "-";
  }
  return typeof value === "string" ? value : "-";
}

export function formatFieldValue(value, config, schemas) {
  const isPointer = config?.type === "Pointer" && config?.target;
  if (isPointer) {
    return formatPointerDisplay(value, config.target, schemas);
  }
  return value !== undefined && value !== null ? String(value) : "-";
}
